
    import './styles.scoped.css';
    export default {
  "navigation-container": "awsui_navigation-container_2p2ab_1inv6_153",
  "is-navigation-open": "awsui_is-navigation-open_2p2ab_1inv6_164",
  "navigation": "awsui_navigation_2p2ab_1inv6_153",
  "hide-navigation": "awsui_hide-navigation_2p2ab_1inv6_184"
};
  